var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingGreyActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eConsult-settings---click",
    transform: "translate(-26.000000, -674.000000)",
    stroke: "#7AB642",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(27.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4595172,9.93103448 L18,9.93103448 L18,7.44827586 L15.4585862,7.44827586 C15.2987586,6.79375862 15.0275172,6.11968966 14.6737241,5.53965517 L16.4706207,3.74275862 L14.2566207,1.52937931 L12.4594138,3.32596552 C11.8793793,2.97217241 10.9008621,2.60875862 10.5517241,2.54110345 L10.5517241,0 L7.44827586,0 L7.44827586,2.54110345 C7.04575862,2.62831034 6.11937931,2.97217241 5.53996552,3.32596552 L3.74244828,1.52937931 L1.52875862,3.74275862 L3.32565517,5.54027586 C2.97186207,6.11968966 2.63296552,7.06531034 2.53986207,7.44827586 L0,7.44827586 L0,9.93103448 L2.53986207,9.93103448 C2.6667931,10.8766552 2.97186207,11.8803103 3.32565517,12.4597241 L1.52813793,14.2572414 L3.74244828,16.4706207 L5.53934483,14.6731034 C6.11937931,15.0278276 7.14724138,15.2953448 7.44827586,15.4595172 L7.44827586,18 L10.5517241,18 L10.5517241,15.4595172 C10.8524483,15.2953448 11.8803103,15.0278276 12.4594138,14.6740345 L14.2572414,16.4706207 L16.4706207,14.2572414 L14.6737241,12.4597241 C15.0275172,11.8803103 15.2950345,11.4734483 15.4595172,9.93103448 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,8.92498779 C12.25,10.7889082 10.7389205,12.2999878 8.875,12.2999878 C7.01077273,12.2999878 5.5,10.7889082 5.5,8.92498779 C5.5,7.06106734 7.01077273,5.54998779 8.875,5.54998779 C10.7389205,5.54998779 12.25,7.06106734 12.25,8.92498779 Z",
    id: "Stroke-3"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingGreyActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/setting-grey-active.40b2953836afda31a366c845e5c183cb.svg";